module.exports = __webpack_public_path__ + "img/item-1.281f3181.png";